import { FormattedMessage } from 'react-intl';

// assets
import { ReadOutlined, ContactsOutlined, BankOutlined, AuditOutlined, ProfileOutlined } from '@ant-design/icons';

// icons
const icons = {
  ContactsOutlined,
  BankOutlined,
  AuditOutlined,
  ProfileOutlined,
  ReadOutlined
};

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const contracts = {
  id: 'contracts_parent',
  title: '',
  type: 'group',
  children: [
    {
      id: 'contracts',
      title: <FormattedMessage id="menu-items.contracts" />,
      icon: icons.ContactsOutlined,
      url: '/contracts',
      type: 'item'
    }
  ]
};

export default contracts;
